"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm._m(0);
};
var staticRenderFns = exports.staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("section", [_c("html", [_c("head"), _c("body", [_c("h1", [_vm._v("ReportSubjectEditor 报表添加科目组件")]), _c("p", [_vm._v("用于为智能报表、智能看板添加科目。")]), _c("p", [_c("strong", [_vm._v("注意：使用该组件需要在主项目安装 "), _c("code", {
    pre: true
  }, [_vm._v("sortablejs ^1.15.0")]), _vm._v(" 依赖包，"), _c("code", {
    pre: true
  }, [_vm._v("yarn add sortablejs")])])]), _c("h2", [_vm._v("代码演示")]), _c("pre", {
    pre: true
  }, [_c("code", {
    pre: true,
    attrs: {
      "v-pre": "",
      class: "language-js"
    }
  }, [_vm._v("<template>\n  "), _c("span", {
    pre: true,
    attrs: {
      class: "language-xml"
    }
  }, [_c("span", {
    pre: true,
    attrs: {
      class: "hljs-tag"
    }
  }, [_vm._v("<"), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-name"
    }
  }, [_vm._v("ReportSubjectEditor")]), _vm._v(" "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-attr"
    }
  }, [_vm._v("v-model")]), _vm._v("="), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-string"
    }
  }, [_vm._v('"form.content"')]), _vm._v(" "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-attr"
    }
  }, [_vm._v(":dimension")]), _vm._v("="), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-string"
    }
  }, [_vm._v('"form.dimension"')]), _vm._v(" "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-attr"
    }
  }, [_vm._v(":biz-type")]), _vm._v("="), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-string"
    }
  }, [_vm._v('"form.bizType"')]), _vm._v(" "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-attr"
    }
  }, [_vm._v(":source")]), _vm._v("="), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-string"
    }
  }, [_vm._v('"form.source"')]), _vm._v(" "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-attr"
    }
  }, [_vm._v(":type")]), _vm._v("="), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-string"
    }
  }, [_vm._v('"form.type"')]), _vm._v(">")]), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-tag"
    }
  }, [_vm._v("</"), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-name"
    }
  }, [_vm._v("ReportSubjectEditor")]), _vm._v(">")])]), _vm._v("\n</template>\n\n"), _c("span", {
    pre: true,
    attrs: {
      class: "language-xml"
    }
  }, [_c("span", {
    pre: true,
    attrs: {
      class: "hljs-tag"
    }
  }, [_vm._v("<"), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-name"
    }
  }, [_vm._v("script")]), _vm._v(">")]), _c("span", {
    pre: true,
    attrs: {
      class: "language-javascript"
    }
  }, [_vm._v("\n"), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-keyword"
    }
  }, [_vm._v("import")]), _vm._v(" "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-title class_"
    }
  }, [_vm._v("ReportSubjectEditor")]), _vm._v(" "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-keyword"
    }
  }, [_vm._v("from")]), _vm._v(" "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-string"
    }
  }, [_vm._v("'@ys/micro-components/ReportSubjectEditor'")]), _vm._v("\n\n"), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-keyword"
    }
  }, [_vm._v("export")]), _vm._v(" "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-keyword"
    }
  }, [_vm._v("default")]), _vm._v(" {\n  "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-attr"
    }
  }, [_vm._v("components")]), _vm._v(": {\n    "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-title class_"
    }
  }, [_vm._v("ReportSubjectEditor")]), _vm._v("\n  },\n  "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-title function_"
    }
  }, [_vm._v("data")]), _vm._v("("), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-params"
    }
  }), _vm._v(") {\n   "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-keyword"
    }
  }, [_vm._v("return")]), _vm._v(" {\n     "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-attr"
    }
  }, [_vm._v("form")]), _vm._v(": {\n        "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-attr"
    }
  }, [_vm._v("bizType")]), _vm._v(": "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-string"
    }
  }, [_vm._v("'Report'")]), _vm._v(", "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-comment"
    }
  }, [_vm._v("// 业务类型，Report：智能报表，Card：卡片，Chart1：柱状图，Chart2：折线图; 这里固定为“Report”")]), _vm._v("\n        "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-attr"
    }
  }, [_vm._v("content")]), _vm._v(": "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-string"
    }
  }, [_vm._v("''")]), _vm._v(", "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-comment"
    }
  }, [_vm._v("// 模板内容，json字符串格式")]), _vm._v("\n        "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-attr"
    }
  }, [_vm._v("dimension")]), _vm._v(": "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-string"
    }
  }, [_vm._v("'Shop'")]), _vm._v(", "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-comment"
    }
  }, [_vm._v("// 统计维度，Shop：店铺，Anchor：主播，Sku：单品")]), _vm._v("\n        "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-attr"
    }
  }, [_vm._v("type")]), _vm._v(": "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-string"
    }
  }, [_vm._v("'Static'")]), _vm._v(", "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-comment"
    }
  }, [_vm._v("// 模板类型，Static：利润报表，Dynamic：实时业绩报表")]), _vm._v("\n        "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-attr"
    }
  }, [_vm._v("source")]), _vm._v(": "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-string"
    }
  }, [_vm._v("'Common'")]), _vm._v(" "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-comment"
    }
  }, [_vm._v("// 来源，Personal：个人模板，Common：公共模板")]), _vm._v("\n      }\n   }\n  }\n}\n")]), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-tag"
    }
  }, [_vm._v("</"), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-name"
    }
  }, [_vm._v("script")]), _vm._v(">")])]), _vm._v("\n")])]), _c("h2", [_vm._v("API")]), _c("table", [_c("thead", [_c("tr", [_c("th", [_vm._v("参数")]), _c("th", [_vm._v("说明")]), _c("th", [_vm._v("类型")]), _c("th", [_vm._v("默认值")]), _c("th", [_vm._v("版本")])])]), _c("tbody", [_c("tr", [_c("td", [_vm._v("value(v-model)")]), _c("td", [_vm._v("经过"), _c("code", {
    pre: true
  }, [_vm._v("JSON.stringify()")]), _vm._v("编码后的 json 字符串")]), _c("td", [_c("code", {
    pre: true
  }, [_vm._v("String")]), _vm._v("，字段结构请看"), _c("code", {
    pre: true
  }, [_vm._v("./useReportSubjectEditor.js中的DEFAULT_TPL_CONFIG")])]), _c("td", [_vm._v("''")]), _c("td")]), _c("tr", [_c("td", [_vm._v("dimension")]), _c("td", [_vm._v("统计维度，可选值"), _c("code", {
    pre: true
  }, [_vm._v("Shop：店铺，Anchor：主播，Sku：单品")])]), _c("td", [_c("code", {
    pre: true
  }, [_vm._v("String")])]), _c("td"), _c("td")]), _c("tr", [_c("td", [_vm._v("bizType")]), _c("td", [_vm._v("业务类型，可选值"), _c("code", {
    pre: true
  }, [_vm._v("Report：智能报表，Card：卡片，Chart1：柱状图，Chart2：折线图")])]), _c("td", [_c("code", {
    pre: true
  }, [_vm._v("String")])]), _c("td", [_vm._v("Report")]), _c("td")]), _c("tr", [_c("td", [_vm._v("source")]), _c("td", [_vm._v("来源，可选值"), _c("code", {
    pre: true
  }, [_vm._v("Personal：个人模板，Common：公共模板")]), _vm._v("，该值为"), _c("code", {
    pre: true
  }, [_vm._v("Personal")]), _vm._v("时，type 只能为"), _c("code", {
    pre: true
  }, [_vm._v("Dynamic")])]), _c("td", [_c("code", {
    pre: true
  }, [_vm._v("String")])]), _c("td", [_vm._v("Common")]), _c("td")]), _c("tr", [_c("td", [_vm._v("type")]), _c("td", [_vm._v("模板类型，可选值"), _c("code", {
    pre: true
  }, [_vm._v("Static：利润报表，Dynamic：实时业绩报表")])]), _c("td", [_c("code", {
    pre: true
  }, [_vm._v("String")])]), _c("td", [_vm._v("Static")]), _c("td")]), _c("tr", [_c("td", [_vm._v("limit")]), _c("td", [_vm._v("最多能添加的一级科目数量，0 表示不限制")]), _c("td", [_c("code", {
    pre: true
  }, [_vm._v("Number")])]), _c("td", [_vm._v("0")]), _c("td")]), _c("tr", [_c("td", [_vm._v("desc")]), _c("td", [_vm._v("添加按钮后面的提示语")]), _c("td", [_c("code", {
    pre: true
  }, [_vm._v("String")])]), _c("td", [_vm._v("''")]), _c("td")]), _c("tr", [_c("td", [_vm._v("scroll")]), _c("td", [_vm._v("组件内部的 table 组件的"), _c("code", {
    pre: true
  }, [_vm._v("scroll")]), _vm._v("属性")]), _c("td", [_c("code", {
    pre: true
  }, [_vm._v("Object")])]), _c("td", [_vm._v("{ x: false, y: false }")]), _c("td")]), _c("tr", [_c("td", [_vm._v("showSelectFormulaEntry")]), _c("td", [_vm._v("是否显示“选择已有公式科目”入口")]), _c("td", [_c("code", {
    pre: true
  }, [_vm._v("Boolean")])]), _c("td", [_vm._v("true")]), _c("td")])])]), _c("h2", [_vm._v("事件")]), _c("table", [_c("thead", [_c("tr", [_c("th", [_vm._v("事件名称")]), _c("th", [_vm._v("说明")]), _c("th", [_vm._v("回调参数")]), _c("th", [_vm._v("版本")])])]), _c("tbody", [_c("tr", [_c("td", [_vm._v("change")]), _c("td", [_vm._v("科目内容发生变化时的回调，"), _c("code", {
    pre: true
  }, [_vm._v("value")]), _vm._v("经过 "), _c("code", {
    pre: true
  }, [_vm._v("JSON.stringify()")]), _vm._v(" 编码")]), _c("td", [_c("code", {
    pre: true
  }, [_vm._v("(value) => void")])]), _c("td", [_vm._v("-")])])])])])])]);
}];
render._withStripped = true;